import { isMobileDevice } from "@stadium/helpers/device";

export const alreadyRedeemed = "alreadyRedeemed";
export const notInvited = "notInvited";
export const treatExpired = "treatExpired";
export const treatNotFound = "treatNotFound";

export const MESSAGE_THRESHOLD = isMobileDevice ? 125 : 180;

export const DONT_SHOW_VIDEO_FOR_ERRORS = [notInvited, treatExpired, treatNotFound];
